import React, { useState, useEffect } from "react";

const manualCategories = (lang) => ({
    footer: [
        {
            name: "Sport Rules",
            target_name: "Sport_Rules",
            target_page: "/Sport_Rules",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/sport_rules.php`,
        },
        {
            name: "Bonus Multipla",
            target_name: "bonus_table",
            target_page: "/bonus_table",
            external_url: ``,
        },
    ],
    footer1: [
        {
            name: "Casino FAQ",
            target_name: "Casino_FAQ",
            target_page: "/Casino_FAQ",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/casino_faq.php`,
        },
    ],
    footerCUSTOM1: [
        {
            name: "AML/KYC Policy",
            target_name: "AML_KYC",
            target_page: "/AML_KYC",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/aml_kyc_policy.php`,
        },
        {
            name: "Fairness & RNG Testing Methods",
            target_name: "Fairness_RNG",
            target_page: "/Fairness_RNG",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/fairness_rng.php`,
        },
        {
            name: "Responsible Gaming",
            target_name: "Responsible_Gaming",
            target_page: "/Responsible_Gaming",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/responsible_gaming.php`,
        },
        {
            name: "Privacy & Policy",
            target_name: "Privacy_Policy",
            target_page: "/Privacy_Policy",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/privacy_policy.php`,
        },
        {
            name: "Terms and Conditions",
            target_name: "Terms_Conditions",
            target_page: "/Terms_Conditions",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/terms_and_conditions.php`,
        },
    ],
    footerCUSTOM2: [
        {
            name: "About us",
            target_name: "About_us",
            target_page: "/About_us",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/about_us.php`,
        },
        {
            name: "Contact",
            target_name: "Contact",
            target_page: "/Contact",
            external_url: `https://cloud.gsplattform.com/infopage/7vegas/${lang}/contact.php`,
        },
    ],
});

const CustomMenuFooter = ({
    menu_name,
    type,
    selection,
    activePage,
    onNavigationChange,
    lang,
    casinoSections,
}) => {
    const [buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchMenuButtons = async () => {
            setLoading(true);
            try {
                let fetchedButtons = [];
                if (type !== "custom") {
                    const response = await fetch(
                        "https://cms.gamesolutions.org/api/get_menu_buttons",
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                menu_name,
                                menu_type: type,
                            }),
                        },
                    );
                    const data = await response.json();
                    fetchedButtons =
                        data.status && data.buttons ? data.buttons : [];
                }

                const categoryButtons = manualCategories(lang)[menu_name] || [];
                setButtons([...categoryButtons, ...fetchedButtons]);
            } catch (error) {
                console.error("Error fetching menu buttons:", error);
                setButtons(manualCategories(lang)[menu_name] || []);
            } finally {
                setLoading(false);
            }
        };
        fetchMenuButtons();
    }, [menu_name, type, lang]);

    const handleButtonClick = (button) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (onNavigationChange) {
            const externalUrl = manualCategories(lang)[menu_name]?.some(
                (b) => b.target_name === button.target_name,
            )
                ? button.external_url
                : null;
            onNavigationChange(
                button.target_name,
                button.target_page,
                Boolean(externalUrl),
                externalUrl,
            );
        }
    };

    return (
        <div>
            <div className="accordion-plus_footer">
                <a
                    href={`#footer_${menu_name}`}
                    className="title-footer collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#footer_${menu_name}`}
                    aria-expanded="false"
                >
                    {selection}
                </a>
            </div>
            <div id={`footer_${menu_name}`} className="collapse">
                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <ul className="footer-link">
                            {buttons
                                .filter((button) => {
                                    const mustFilter = [
                                        "sport",
                                        "live",
                                        "casino-live",
                                    ].includes(button.target_name);
                                    return mustFilter
                                        ? !casinoSections[button.target_name]
                                        : true;
                                })
                                .map((button, index) => (
                                    <li
                                        key={index}
                                        className={
                                            activePage === button.target_name
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() =>
                                            handleButtonClick(button)
                                        }
                                        style={{ cursor: "pointer" }}
                                    >
                                        <a
                                            href={button.target_page || "#"}
                                            className="custom-button"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            {button.name}
                                        </a>
                                    </li>
                                ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomMenuFooter;
